import * as React from 'react'
import { ReactElement } from 'react'
import EnumPicker, { EnumPickerLabel, EnumPickerProps } from './EnumPicker'
import { Billable } from '../../config/registration/timeConfig'

export type BillablePickerProps = Partial<EnumPickerProps<Billable>> &
    Required<Pick<EnumPickerProps<Billable>, 'selectedOptions' | 'onOptionsSelect'>>

// The order matters for dropdowns.
export const BillableLabels = new Map<Billable, EnumPickerLabel>([
    [Billable.Billable, { name: 'base.billable.billable', disabled: false }],
    [Billable.Offered, { name: 'base.billable.offered', disabled: false }],
    [Billable.NotBillable, { name: 'base.billable.notbillable', disabled: false }],
])

export default function BillablePicker(props: BillablePickerProps): ReactElement {
    return (
        <EnumPicker<Billable> options={[...BillableLabels.keys()]} labels={BillableLabels} placeholderKey={'base.billable.placeholder'} {...props} />
    )
}
